module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog-prompt', {
    ref: "dialog",
    attrs: {
      "value": _vm.value !== null ? _vm.value : '',
      "md-title": "Введите имя документа",
      "md-input-maxlength": "30",
      "md-confirm-text": _vm.confirmText
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      },
      "close": _vm.close
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3c90e8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocNameDialog.vue
// module id = 1023
// module chunks = 1